import 'reflect-metadata';
import { jsonObject, jsonMember, jsonArrayMember, toJson, TypedJSON } from 'typedjson';

@jsonObject
@toJson
export class Point {
  @jsonMember(Number)
  public x!: number;

  @jsonMember(Number)
  public y!: number;
}

export const pointSerializer = new TypedJSON(Point);

@jsonObject
@toJson
export class Area {
  @jsonArrayMember(Point)
  public points: Point[] = [];
}

export const serializer = new TypedJSON(Area);
